import { useMemo } from 'react'
import { getColumns, getRows } from './helpers'
import { Table } from '@fullscreendigital/carrefour-dex-fe'

const DeliveryMatrixDetails = ({ item, tableColumns }) => {
  const { depositNameList, paxdDepositNameList, hubNameList, acceptReturnsList } = item

  const rows = useMemo(
    () => getRows(depositNameList, paxdDepositNameList, hubNameList, acceptReturnsList),
    [depositNameList, paxdDepositNameList, hubNameList, acceptReturnsList]
  )

  const columns = useMemo(() => getColumns(tableColumns), [])

  return (
    <Table
      hideCheckbox
      columns={columns}
      rows={rows}
      isLoading={false}
      disablePagination
    />
  )
}

export default DeliveryMatrixDetails
